import { Injectable } from '@angular/core';
import { ERROR_CODE } from './ERROR_CODE';
import { HttpClient } from '@angular/common/http';
import { URL_INICIO, URL_Refresh_tocken, URL_session } from '../constantes';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class KeycloakService {

  token:string|null=null;

  constructor(private http: HttpClient) { }

  setAccesTocken(token:string){ 
    this.token=token;
  }

  async loadAccesTocken(){
    if(this.token) return this.token; //si ya lo tenia cargado en sesion no hagonada
    let token:any = await lastValueFrom(this.http.get(URL_session))
      .catch(er=> {console.error("no se pudo recuperar el acces tocken",er)})
    if(token && token.token) {
      this.token = token.token
      return token.token;
    }return null
  }

  private async refrescarToken(): Promise<any>{
    let token:any = await lastValueFrom(this.http.get(URL_Refresh_tocken))
      .catch(er=> {console.error("no se pudo recuperar el acces tocken",er)})
    if(token && token.token) {
      this.token = token.token
      return token.token;
    }return null
  }
 
  /** manejo de la app, para la incorporación del acces token */
  private async peticionMaster(
    metodo:string="GET",
    path:string,
    body:any=null 
  ){
    let peticionar=async(token:any)=>{
      if(token){
        /** Agrego cabeceras para la petición */
        let options:any = {
          headers: {
            'Authorization':'Bearer '+token,
            'Access-Control-Allow-Origin': '*', 
            'Content-Type': 'application/json'
          },
        };
        if(body) options.data = JSON.stringify(body)
        switch (metodo){
          case "POST": return await lastValueFrom( this.http.post(path,JSON.stringify(body),options));
          case "PUT": return await lastValueFrom( this.http.put(path,JSON.stringify(body),options));
          default: return await lastValueFrom( this.http.get(path,options));
        }
      }else return null
    }

    try{
      let resp:any= await peticionar(this.token).catch(
        async err=>{ 
          if(!environment.production) 
            console.error("se obtuvo un error y se reintentará la peticion luego de refrescar el token",err)
          }
      );
      if(!resp){
        let token:any = await this.refrescarToken()
        if(!token) throw (ERROR_CODE.session_expirada);
        return await peticionar(token)
      }else{
        return resp;
      }
    }catch(e:any){
      this.error_handler(e)
      throw e;
    }
  }

  async get(path: string): Promise<any> {
    return await this.peticionMaster("GET",path);
  }

  async post(path: string, body:any): Promise<any>{    
    return await this.peticionMaster("POST",path,body);
  }

  async put(path: string, body:any): Promise<any>{    
    return await this.peticionMaster("PUT",path,body);
  }

  error_handler(e:any){
    console.error(e)
    if(e == ERROR_CODE.session_expirada){
      this.desloguear()
    }
  }

  desloguear(sinMensaje=false) {
    this.token = null;
    if(!sinMensaje) alert("Session Expirada");
    sessionStorage.clear();
    document.location = window.location.origin + URL_INICIO
  }

}
